import React, { FC } from "react";

import Footer from './Footer';
import "./layout.css";

const Layout: FC = ({ children }) => {
  return (
    <div
      className="container"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        maxWidth: 960,
        padding: `0px 4px`,
        margin: `0 auto`,
        paddingTop: 0,
      }}
    >
      <main
        style={{
          flexGrow: 1,
        }}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
